// images
import d1 from "../../icons/email.png" 
import d2 from "../../icons/d2.png" 
import d3 from "../../icons/d3.png" 
import React from 'react';
import tr24 from "../../triangles/tr24.png"
import tr25 from "../../triangles/tr25.png"
import tr26 from "../../triangles/tr26.png"
import tr27 from "../../triangles/tr27.png"

import {Environment} from '../../constants/environment.ts';
import {sharedApiHeaders} from '../../constants/sharedApi.ts';
// Imports 
import { Button, Stack, Typography } from "@mui/material";
import "./Demo.scss"
import { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BeatLoader } from 'react-spinners';
import Modal from 'react-modal';
Modal.setAppElement('#root'); 


const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: '1px solid #ccc',
      borderRadius: '10px',
      padding: '20px',
      width: '300px',
    } 
};
function Demo() {

  useEffect(() => {
    window.scrollTo(0, 0);
} , [])
  
  return (
    <div className="Demo">
      <First />
      <Second />
    </div>
  );
}

function First() {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (event) => {
    // Prevent page reload
    event.preventDefault();
     // Create a FormData object from the form
     const formData = new FormData(event.target);
    setLoading(true);
    const activeCommercialRegister=formData.get('activeCommercialRegister'); // 'Yes' or 'No'
    const activeTaxNumber=formData.get('activeTaxNumber'); // 'Yes' or 'No'
    await fetch(`${Environment.ertikazApi}/send`, {
       method: 'POST',
       body: JSON.stringify({
          name: document.getElementsByName('name')[0]?.value,
          companyName: document.getElementsByName('companyName')[0]?.value,
          mobile: document.getElementsByName('mobile')[0]?.value,
          email: document.getElementsByName('email')[0]?.value,
          demoDate: document.getElementsByName('demoDate')[0]?.value,
          activeTaxNumber:activeTaxNumber==='Yes',
          activeCommercialRegister:activeCommercialRegister==='Yes',
          finance:true
       }),
       headers: sharedApiHeaders({
          'Content-type': 'application/json; charset=UTF-8',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*'
       }),
    }).then((res)=>{
      if(!res.ok) throw new Error(`http ${res.status}`);
      setLoading(false);
      let infoMessage='';
      if(localStorage.getItem("lang") === "ar"){
          infoMessage='تم إرسال الطلب بنجاح';
        }
        else{
          infoMessage='Request has been sent successfully';
        }
      toast.success(infoMessage);
      }).catch(e=>{
      setLoading(false);
      console.log(e);
      toast.error('Error');
    });
  };
  
  if(localStorage.getItem("lang") === "en") {
    return (
      <div className="dFirst">
           <Modal isOpen={loading} style={customStyles}>
        <BeatLoader color="#4A90E2" />
      </Modal>
   <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        />
        <img src={tr24} alt="" className="tr24" />
        <img src={tr25} alt="" className="tr25" />
        <img src={tr26} alt="" className="tr26" />
        <img src={tr27} alt="" className="tr27" />
        
        <Stack width="fit-content" py={{xs : 20 , sm : 40}} px={{xs: 10 , sm :25}} border="1px solid" borderColor="text" alignItems="center" borderRadius="50px" mx="auto">
          <Typography color="secondary" sx={{
            fontWeight : "700",
            fontSize : {xs : "40px" , sm : "48px"},
            lineHeight : "50px",
          }}>
          Book a demo
          </Typography>
          <Typography sx={{
            fontWeight : "400",
            fontSize : {xs : "20px" , sm : "24px"},
            lineHeight : {xs : "20px" , sm : "40px"},
            textAlign : {xs : "center" , sm : "left"} ,
            mb :24
          }}>
          Please fill the below form and our team will be in touch.
          </Typography>
          <form onSubmit={handleSubmit}>
            <Stack spacing={12} mb={24} alignItems="center">
              <input required type="text" placeholder="Name" name="name" />
              <input required type="text" placeholder="Company" name="companyName" />
              <input required type="number" placeholder="Mobile" name="mobile" />
              <input required type="email" placeholder="Email" name="email" />
              <input required type="text" className="date" name="demoDate" placeholder="Demo date" 
                onFocus={(e) => {
                  e.target.type = "date"
                }}
              />

          <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              Do you have an effective commercial register? 
            <label style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="Yes"
                required 
                style={{margin:"17px 0 17px 25px"}} 

              />
              Yes
            </label>
            <label style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="No"
                required 
                style={{margin:"17px 0 17px 35px"}} 
                
              />
              No
            </label> 
            
          </Typography>

          <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              Do you have an effective tax number? 
            <label style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber"
                value="Yes"
                required
                style={{margin:"17px 0 17px 25px"}} 

              />
              Yes
            </label>
            <label style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber"
                value="No"
                required 
                style={{margin:"17px 0 17px 35px"}} 
                
              />
              No
            </label> 
            
          </Typography>
            </Stack>
            <Stack alignItems="center">
              <Button type="submit" variant="contained" sx={{
                  py : 9 , px : 40, width : "fit-content", borderRadius : "18px",
                  "&:hover": { color: "secondary.main" },
                }}>Book now</Button>
            </Stack>
          </form>
        </Stack>
      </div>
    );
  } else {
    return (
      <div className="dFirst">
         <Modal isOpen={loading} style={customStyles}>
        <BeatLoader color="#4A90E2" />
      </Modal>
   <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        />
        <img src={tr24} alt="" className="tr24" />
        <img src={tr25} alt="" className="tr25" />
        <img src={tr26} alt="" className="tr26" />
        <img src={tr27} alt="" className="tr27" />
        
        <Stack width="fit-content" py={{xs : 20 , sm : 40}} px={{xs: 10 , sm :25}} border="1px solid" borderColor="text" alignItems="center" borderRadius="50px" mx="auto">
          <Typography color="secondary" sx={{
            fontWeight : "700",
            fontSize : {xs : "40px" , sm : "48px"},
            lineHeight : "70px",
          }}>
          احجز عرض توضيحي
          </Typography>
          <Typography sx={{
            fontWeight : "400",
            fontSize : {xs : "20px" , sm : "24px"},
            lineHeight : {xs : "20px" , sm : "40px"},
            textAlign : {xs : "center" , sm : "left"} ,
            mb :24
          }}>
          يرجى ملء النموذج أدناه وسيتواصل معك فريقنا.
          </Typography>
          <form onSubmit={handleSubmit}>
            <Stack spacing={12} mb={24} alignItems="center">
              <input required type="text" placeholder="الاسم" name="name" /> 
              <input required type="text" placeholder="الشركة" name="companyName" />
              <input required type="number" placeholder="الهاتف" name="mobile" />
              <input required type="email" placeholder="الايميل" name="email" />
              <input required type="text" className="date" name="demoDate" placeholder="تاريخ العرض التجريبي" 
                onFocus={(e) => {
                  e.target.type = "date"
                }}
              />
                        <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              هل تمتلك سجل تجاري فعّال؟ 
              <label style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="Yes"
                required
                style={{margin:"17px 5px 17px 0"}} 
              />
              نعم
            </label>
            <label style={{ width:"75px",display: 'inline-flex'}}>
              <input
                type="radio"
                name="activeCommercialRegister"
                value="No"
                required
                style={{margin:"17px 35px 17px 0"}} 
                
              />
              لا
            </label> 
            
          </Typography>

          <Typography sx={{
           fontWeight : "400",
           fontSize : {xs : "16px" , sm : "20px"},
           lineHeight : {xs : "10px" , sm : "40px"},
           textAlign : {xs : "center" , sm : "left"} 
          }}>
              هل لديك رقم ضريبي فعّال؟ 
            <label style={{ width:"75px",display: 'inline-flex' }}>
              <input
                type="radio"
                name="activeTaxNumber"
                value="Yes"
                required
                style={{margin:"17px 5px 17px 0"}} 
              />
              نعم
            </label>
            <label style={{ width:"75px",display: 'inline-flex'}}>
              <input
                type="radio"
                name="activeTaxNumber"
                value="No"
                required
                style={{margin:"17px 35px 17px 0"}} 
                
              />
              لا
            </label> 
            
          </Typography>
            </Stack>
            <Stack alignItems="center">
              <Button type="submit" variant="contained" sx={{
                  py : 9 , px : 40, width : "fit-content", borderRadius : "18px",
                  "&:hover": { color: "secondary.main" },
                }}>احجز الان</Button>
            </Stack>
          </form>
        </Stack>
      </div>
    );
  }
}

export function Second() {
  return (
    <div className="dSecond">
      
      <Stack alignItems="center" pb={80}>
        <Typography color="text.secondary" sx={{
          fontWeight : "700",
          fontSize : "20px",
          mb : 12
        }}>
        

        {localStorage.getItem("lang") === "en" ? "For support please contact us at" :"للدعم يرجي التواصل معنا عبر" }
        
        </Typography>
        <Stack direction="row" spacing={16}>
          <Link to="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=info@ertikaz.tech" target="_blank"><img src={d1} alt="" /></Link>
          <Link to="https://api.whatsapp.com/send?phone=966550379547&text=Welcome%20To%20Lean%20Finance" target="_blank"><img src={d2} alt="" /></Link>
          <Link to="https://www.youtube.com/@ertikazTechnology" target="_blank"><img src={d3} alt="" /></Link>
        </Stack>
      </Stack>
    </div>
  );
}

export default Demo ;